
/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Existing Missions container
Author: Deimos Space UK

Version: 1.0
*/
import React from "react";
import { Col, Container, Row } from "reactstrap";
import MissionList from "../components/MissionList";
import EffectMapExistingMissions from "../components/EffectMapExistingMissions";
import EnvironmentIndex from "../components/EnvironmentIndex";

export default function ExistingMissions() {

  

  return (
    <Container>
      <Row>
        <Col xs={12}>
          <h3 style={{ color: '#003247' }}>Existing Missions</h3>
        </Col>

      </Row>
      <Row>
        <Col><EffectMapExistingMissions /></Col>
        
      </Row>
      <Row className="pt-3">
      <Col xs={12}><EnvironmentIndex /></Col>
      </Row>
      <Row className="mt-3">
        <Col><MissionList /></Col>
      </Row>
    </Container>
  );
}
